import { FC } from "react";
import { get } from "lodash";
import { Select, SelectOption } from "../../Components/Select/Select";
import { TextInput } from "../../Components/TextInput/TextInput";
import type { MetadataReadonlyOption } from "../../Generated/graphql";

type Props = {
  // GraphQL JSON may contain scalars or objects; formatting does not require a narrower shape.
  value: unknown;
  jsonPath?: string | null;
  options?: readonly MetadataReadonlyOption[] | null;
};

/** Metadata can supply labels without making a BC-owned value editable. */
export const ReadonlyJSONField: FC<Props> = ({ value, jsonPath, options }) => {
  const formattedValue = formatReadonlyJSONValue(value, jsonPath ?? "");

  if (options?.length) {
    return (
      <Select disabled value={formattedValue} defaultText={formattedValue}>
        {options.map((option) => (
          <SelectOption key={option.value} value={option.value}>
            {option.label}
          </SelectOption>
        ))}
      </Select>
    );
  }

  return <TextInput value={formattedValue} readOnly />;
};

/**
 * Empty paths display scalar values directly; other paths select nested JSON.
 * @param json GraphQL JSON can have any shape, so only lookup and string conversion are assumed.
 */
export const formatReadonlyJSONValue = (
  json: unknown,
  path: string,
  defaultValue = "",
): string => {
  const value = path === "" ? json : get(json, path);
  // Nullish fallback preserves false and 0, while also handling explicit nested nulls.
  return String(value ?? defaultValue);
};
